import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { BsFire } from 'react-icons/bs'
import { logEvent } from '@firebase/analytics'
import analytics from '../Utils/FirebaseAnalytics'
import { pluralBs } from '../Utils/Helpers'

/* In-feed row of the current story topics (the desktop sidebar's "Aktuelne
   teme"), for screens where the sidebar is hidden. */
export default function TrendingTopics() {
  const navigate = useNavigate()
  const { topics } = useSelector((state) => state.news)

  const items = (topics ?? []).filter((t) => t.is_category === false && t.news_count > 0).slice(0, 10)
  if (items.length === 0) {
    return null
  }

  return (
    <section className="trending-topics d-lg-none">
      <h3>
        <BsFire /> {`Aktuelne teme`}
      </h3>
      <div className="trending-topics-row">
        {items.map((topic) => (
          <button
            type="button"
            key={topic.id}
            className="trending-topic"
            onClick={() => {
              navigate(`/tema/${topic.name}`)
              logEvent(analytics, 'w_topic_opened', { item: topic.name })
            }}
          >
            <span className="trending-topic-name">{topic.name}</span>
            <span className="trending-topic-count">
              {`${topic.news_count} ${pluralBs(topic.news_count, 'novost', 'novosti', 'novosti')}`}
            </span>
          </button>
        ))}
      </div>
    </section>
  )
}
